import { type FC } from 'react'
import classNames from 'classnames'
import { type ItemGroup } from '../domain/collections'
import { ErrorText, SpinnerLine } from './flowPrimitives'

interface StepInfoRailProps {
  groups: ItemGroup[]
  invalidGroups?: ItemGroup[]
  heading: string
  missingHeading: string
  invalidHeading?: string
  confirmLabel: string
  loading?: boolean
  loadingMessage?: string
  error?: string | null
  confirmed?: boolean
}

const GroupList: FC<{ heading: string; groups: ItemGroup[]; className?: string }> = ({ heading, groups, className }) => (
  <div className='d-flex flex-column zocks-gap-0.5'>
    <span className={classNames('paragraph-small medium', className)}>{heading}</span>
    {groups.map((group) => (
      <div key={group.key} className='d-flex flex-column zocks-gap-0.25'>
        <span className='paragraph-small medium'>{group.heading}</span>
        <span className='paragraph-small zocks-text-gray-600'>{group.items.map((item) => item.label).join(', ')}</span>
      </div>
    ))}
  </div>
)

export const StepInfoRail: FC<StepInfoRailProps> = ({
  groups,
  invalidGroups = [],
  heading,
  missingHeading,
  invalidHeading,
  confirmLabel,
  loading = false,
  loadingMessage,
  error = null,
  confirmed,
}) => {
  const nothingMissing = !loading && groups.length === 0
  const nothingToReport = nothingMissing && invalidGroups.length === 0

  return (
    <div className='zocks-bg-color-gray-100 rounded-4 p-3 d-flex flex-column zocks-gap-1'>
      <div className='d-flex flex-column align-items-start zocks-gap-0.5'>
        <i className={classNames('fs-5', nothingToReport ? 'bi bi-check-circle zocks-text-success' : 'bi bi-info-circle')} />
        <span className='paragraph-medium medium'>{heading}</span>
      </div>

      {loading ? (
        <SpinnerLine>{loadingMessage}</SpinnerLine>
      ) : (
        <>
          {error ? <ErrorText>{error}</ErrorText> : null}
          {nothingMissing ? null : <GroupList heading={missingHeading} groups={groups} />}
          {invalidGroups.length > 0 && invalidHeading ? (
            <GroupList heading={invalidHeading} groups={invalidGroups} className='zocks-text-warning-text' />
          ) : null}
        </>
      )}

      {confirmed === undefined ? null : (
        <div className='d-flex align-items-start zocks-gap-0.5 border-top pt-2'>
          <i className={classNames('paragraph-small', confirmed ? 'bi bi-check-circle zocks-text-success' : 'bi bi-circle zocks-text-gray-600')} />
          <span className={classNames('paragraph-small mb-0', { 'text-decoration-line-through zocks-text-gray-600': confirmed })}>{confirmLabel}</span>
        </div>
      )}
    </div>
  )
}
